import { ComponentConfig } from "@measured/puck";

import { GridBlock } from "./Grid";
import { GridBlockProps } from "./types";

export type { GridBlockProps } from "./types";

export const Grid: ComponentConfig<GridBlockProps> = {
    label: "Grid",
    fields: {
        columns: {
            type: "select",
            label: "Columns",
            options: [
                { label: "1 Column", value: 1 },
                { label: "2 Columns", value: 2 },
                { label: "3 Columns", value: 3 },
                { label: "4 Columns", value: 4 },
                { label: "5 Columns", value: 5 },
                { label: "6 Columns", value: 6 },
            ],
        },
        rows: {
            type: "select",
            label: "Rows",
            options: [
                { label: "1 Row", value: 1 },
                { label: "2 Rows", value: 2 },
                { label: "3 Rows", value: 3 },
                { label: "4 Rows", value: 4 },
            ],
        },
        spacing: {
            type: "select",
            label: "Spacing",
            options: [
                { label: "Small", value: 1 },
                { label: "Medium", value: 2 },
                { label: "Large", value: 3 },
                { label: "Extra Large", value: 4 },
            ],
        },
        grow: {
            type: "radio",
            label: "Equal height cells",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
        columnWidth: {
            type: "radio",
            label: "Column width distribution",
            options: [
                { label: "Equal", value: "equal" },
                { label: "Content-based", value: "auto" },
                { label: "Emphasis left", value: "custom" },
            ],
        },
    },
    defaultProps: {
        columns: 2,
        rows: 1,
        spacing: 2,
        grow: false,
        columnWidth: "equal",
    },
    render: (props) => {
        return <GridBlock {...props} />;
    },
};
